module.exports = __webpack_public_path__ + "img/ambulance.18d17c73.png";